import { createFileRoute, redirect } from '@tanstack/react-router';
import { clusterCreateSearch } from '@/router/utils';

// Spaces are created on the shared create page, next to free and dedicated clusters.
export const Route = createFileRoute('/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/create')({
  beforeLoad: ({ params: { accountId } }) => {
    throw redirect({
      to: '/accounts/$accountId/clusters/create',
      params: { accountId },
      search: clusterCreateSearch({ template: 'serverless' }),
      replace: true,
    });
  },
});
